module.exports = __webpack_public_path__ + "static/media/search.df1aee3e.svg";